import React, { useEffect, useState, useRef } from 'react';
import { Link } from 'react-router-dom';
import { SearchIcon, EyeIcon, RefreshCwIcon, TrashIcon, ChevronLeftIcon, ChevronRightIcon, Settings2Icon, AlertTriangleIcon, XIcon } from 'lucide-react';
import { Button } from '../components/ui/Button';
// Mock data for soggetti proponenti
const initialSoggetti = [{
  id: 1,
  nomeSocieta: 'Vitali-Verdi e figli',
  email: 'parisi.nadia@example.org',
  codiceFiscale: '68254027484',
  codiceFiscaleRappLegale: 'G3DB14UE16GEJI1',
  emailRappLegale: 'jari06@example.com',
  emailUtente: 'filomena28@example.net',
  nomeUtente: 'Monica Ricci',
  partitaIva: '68254027483',
  codiceMeccanografico: '',
  telefono: '+78 2026 29281769',
  formaGiuridica: 'Società a responsabilità limitata',
  canDelete: true
}, {
  id: 2,
  nomeSocieta: 'Costantini-Sorrentino e figli',
  email: 'bsorrentino@example.org',
  codiceFiscale: '44444444444',
  codiceFiscaleRappLegale: 'G44V6DNS6DLQIFSL',
  emailRappLegale: 'yneri@example.org',
  emailUtente: 'tazio.caruso@example.org',
  nomeUtente: 'Brigitta Galli',
  partitaIva: '16462814993',
  codiceMeccanografico: '',
  telefono: '+05 882 07 88 9988',
  formaGiuridica: 'Società a responsabilità limitata',
  canDelete: false
}, {
  id: 3,
  nomeSocieta: 'Cattaneo-Basile Group',
  email: 'emarchetti@example.com',
  codiceFiscale: 'PG316PD6Z5PUP297',
  codiceFiscaleRappLegale: 'X9UOXQDNGIQ9AJWL',
  emailRappLegale: 'bricci@example.org',
  emailUtente: 'nico.valentini@example.org',
  nomeUtente: 'Fabrizio Mariani',
  partitaIva: '66825635778',
  codiceMeccanografico: '',
  telefono: '043 861 0750',
  formaGiuridica: 'Società a responsabilità limitata',
  canDelete: true
}, {
  id: 4,
  nomeSocieta: 'Riva-Piras e figli',
  email: 'caligola.russo@example.com',
  codiceFiscale: 'T4JATLMN61A9IYOP',
  codiceFiscaleRappLegale: 'M4G15RZDOSOOPRPC',
  emailRappLegale: 'econte@example.org',
  emailUtente: 'ricci.pacifico@example.org',
  nomeUtente: 'Vittorio Serra',
  partitaIva: '28151753767',
  codiceMeccanografico: '',
  telefono: '+39 313 027 064',
  formaGiuridica: 'Società a responsabilità limitata',
  canDelete: true
}, {
  id: 5,
  nomeSocieta: 'Leone-Mariani SPA',
  email: 'caruso.samuel@example.org',
  codiceFiscale: 'GKQOWRP53UO60LWF',
  codiceFiscaleRappLegale: 'MV1Y1KJAXXXJLFDX',
  emailRappLegale: 'margherita.russo@example.net',
  emailUtente: 'xrinaldi@example.net',
  nomeUtente: 'Priamo Ferrari',
  partitaIva: '90025576089',
  codiceMeccanografico: '',
  telefono: '+11 971 8323274',
  formaGiuridica: 'Società a responsabilità limitata',
  canDelete: false
}, {
  id: 6,
  nomeSocieta: 'Martini, Gentile e Marino Group',
  email: 'smarino@example.net',
  codiceFiscale: 'HCC0L5E2WAEPJW76',
  codiceFiscaleRappLegale: 'SNGTMDSDTWJ78BL6',
  emailRappLegale: 'damiano.martinelli@example.net',
  emailUtente: 'ferri.paolo@example.net',
  nomeUtente: 'Valdo Ferraro',
  partitaIva: '48058450242',
  codiceMeccanografico: '',
  telefono: '+99 17 66407263',
  formaGiuridica: 'Società a responsabilità limitata',
  canDelete: true
}, {
  id: 7,
  nomeSocieta: 'Negri-Longo SPA',
  email: 'laerte77@example.net',
  codiceFiscale: '32H7I273N7GNMFY1',
  codiceFiscaleRappLegale: 'THYYEZK7PBBKKWXU',
  emailRappLegale: 'noel.sorrentino@example.net',
  emailUtente: 'bacchisio.monti@example.net',
  nomeUtente: 'Pierina Pellegrino',
  partitaIva: '28961668768',
  codiceMeccanografico: '',
  telefono: '+79 08 65544448',
  formaGiuridica: 'Società a responsabilità limitata',
  canDelete: true
}];
const formaGiuridicaOptions = ['TUTTI', 'Società a responsabilità limitata', 'Società per azioni', 'Società cooperativa', 'Associazione', 'Fondazione', 'Ditta individuale'];
interface TabView {
  id: string;
  name: string;
  filters: {
    nomeSocieta: string;
    email: string;
    codiceFiscale: string;
    codiceFiscaleRappLegale: string;
    emailRappLegale: string;
    emailUtente: string;
    nomeUtente: string;
    partitaIva: string;
    codiceMeccanografico: string;
    telefono: string;
    formaGiuridica: string;
  };
  searchQuery: string;
  rowsPerPage: number;
  currentPage: number;
}
const createDefaultTab = (id: string, name: string): TabView => ({
  id,
  name,
  filters: {
    nomeSocieta: '',
    email: '',
    codiceFiscale: '',
    codiceFiscaleRappLegale: '',
    emailRappLegale: '',
    emailUtente: '',
    nomeUtente: '',
    partitaIva: '',
    codiceMeccanografico: '',
    telefono: '',
    formaGiuridica: 'TUTTI'
  },
  searchQuery: '',
  rowsPerPage: 10,
  currentPage: 1
});
export function SoggettiProponenti() {
  const [soggetti, setSoggetti] = useState(initialSoggetti);
  // Tab System State
  const [tabs, setTabs] = useState<TabView[]>([createDefaultTab('tab-1', 'Tutti')]);
  const [activeTabId, setActiveTabId] = useState<string>('tab-1');
  const [editingTabId, setEditingTabId] = useState<string | null>(null);
  const [editTabName, setEditTabName] = useState('');
  const editInputRef = useRef<HTMLInputElement>(null);
  const activeTab = tabs.find(t => t.id === activeTabId) || tabs[0];
  const updateActiveTab = (updates: Partial<TabView>) => {
    setTabs(prev => prev.map(tab => tab.id === activeTabId ? {
      ...tab,
      ...updates
    } : tab));
  };
  const handleAddTab = () => {
    const newId = `tab-${Date.now()}`;
    const newName = `Vista ${tabs.length + 1}`;
    const newTab = createDefaultTab(newId, newName);
    setTabs([...tabs, newTab]);
    setActiveTabId(newId);
  };
  const handleRemoveTab = (e: React.MouseEvent, idToRemove: string) => {
    e.stopPropagation();
    if (tabs.length <= 1) return;
    const newTabs = tabs.filter(t => t.id !== idToRemove);
    setTabs(newTabs);
    if (activeTabId === idToRemove) {
      setActiveTabId(newTabs[newTabs.length - 1].id);
    }
  };
  const handleDoubleClickTab = (tab: TabView) => {
    setEditingTabId(tab.id);
    setEditTabName(tab.name);
  };
  const handleSaveTabName = () => {
    if (editingTabId && editTabName.trim()) {
      setTabs(prev => prev.map(tab => tab.id === editingTabId ? {
        ...tab,
        name: editTabName.trim()
      } : tab));
    }
    setEditingTabId(null);
  };
  const handleKeyDownTabName = (e: React.KeyboardEvent) => {
    if (e.key === 'Enter') {
      handleSaveTabName();
    } else if (e.key === 'Escape') {
      setEditingTabId(null);
    }
  };
  useEffect(() => {
    if (editingTabId && editInputRef.current) {
      editInputRef.current.focus();
      editInputRef.current.select();
    }
  }, [editingTabId]);
  // Dialogs
  const [deleteDialog, setDeleteDialog] = useState<{
    isOpen: boolean;
    soggettoId: number | null;
    canDelete: boolean;
  }>({
    isOpen: false,
    soggettoId: null,
    canDelete: true
  });
  const [resetDialog, setResetDialog] = useState<{
    isOpen: boolean;
    soggettoId: number | null;
  }>({
    isOpen: false,
    soggettoId: null
  });
  const {
    filters,
    searchQuery,
    rowsPerPage,
    currentPage
  } = activeTab;
  // Filter logic
  const filteredData = soggetti.filter(item => {
    const matchesSearch = item.nomeSocieta.toLowerCase().includes(searchQuery.toLowerCase()) || item.email.toLowerCase().includes(searchQuery.toLowerCase()) || item.codiceFiscale.toLowerCase().includes(searchQuery.toLowerCase());
    const matchesFilters = item.nomeSocieta.toLowerCase().includes(filters.nomeSocieta.toLowerCase()) && item.email.toLowerCase().includes(filters.email.toLowerCase()) && item.codiceFiscale.toLowerCase().includes(filters.codiceFiscale.toLowerCase()) && item.codiceFiscaleRappLegale.toLowerCase().includes(filters.codiceFiscaleRappLegale.toLowerCase()) && item.emailRappLegale.toLowerCase().includes(filters.emailRappLegale.toLowerCase()) && item.emailUtente.toLowerCase().includes(filters.emailUtente.toLowerCase()) && item.nomeUtente.toLowerCase().includes(filters.nomeUtente.toLowerCase()) && item.partitaIva.toLowerCase().includes(filters.partitaIva.toLowerCase()) && item.codiceMeccanografico.toLowerCase().includes(filters.codiceMeccanografico.toLowerCase()) && item.telefono.toLowerCase().includes(filters.telefono.toLowerCase()) && (filters.formaGiuridica === 'TUTTI' || item.formaGiuridica === filters.formaGiuridica);
    return matchesSearch && matchesFilters;
  });
  // Pagination logic
  const totalItems = filteredData.length;
  const totalPages = Math.ceil(totalItems / rowsPerPage) || 1;
  const startItem = totalItems > 0 ? (currentPage - 1) * rowsPerPage + 1 : 0;
  const endItem = Math.min(currentPage * rowsPerPage, totalItems);
  const currentData = filteredData.slice((currentPage - 1) * rowsPerPage, currentPage * rowsPerPage);
  const handleFilterChange = (key: keyof typeof filters, value: string) => {
    updateActiveTab({
      filters: {
        ...filters,
        [key]: value
      },
      currentPage: 1
    });
  };
  const handleDeleteClick = (soggetto: (typeof initialSoggetti)[0]) => {
    setDeleteDialog({
      isOpen: true,
      soggettoId: soggetto.id,
      canDelete: soggetto.canDelete
    });
  };
  const confirmDelete = () => {
    if (deleteDialog.soggettoId) {
      setSoggetti(soggetti.filter(s => s.id !== deleteDialog.soggettoId));
      setDeleteDialog({
        isOpen: false,
        soggettoId: null,
        canDelete: true
      });
    }
  };
  const handleResetClick = (soggettoId: number) => {
    setResetDialog({
      isOpen: true,
      soggettoId
    });
  };
  const confirmReset = () => {
    setResetDialog({
      isOpen: false,
      soggettoId: null
    });
  };
  return <div className="space-y-6" data-id="element-1618">
      {/* Header Card */}
      <div className="bg-white p-8" style={{
      boxShadow: 'none',
      border: '1px solid #E4E4E4',
      borderRadius: '8px'
    }} data-id="element-1619">
        <h1 className="text-[28px] font-normal text-navy-primary font-roboto m-0" data-id="element-1620">
          Gestione Soggetti Proponenti - {activeTab.name}
        </h1>
      </div>

      {/* Tab Bar Workspace */}
      <div className="bg-white flex items-center overflow-x-auto" style={{
      borderRadius: '8px',
      boxShadow: 'none',
      border: '1px solid #E4E4E4',
      padding: '0 32px'
    }} data-id="element-1621">
        <div className="flex items-end gap-2 pt-2" data-id="element-1622">
          {tabs.map(tab => {
          const isActive = tab.id === activeTabId;
          const isEditing = tab.id === editingTabId;
          return <div key={tab.id} onClick={() => setActiveTabId(tab.id)} onDoubleClick={() => handleDoubleClickTab(tab)} className="group flex items-center gap-2 relative transition-colors" style={{
            padding: '14px 16px',
            paddingBottom: '12px',
            cursor: 'pointer',
            color: isActive ? '#293B54' : '#80858E',
            borderBottom: isActive ? '2px solid #2A97DF' : '2px solid transparent',
            fontFamily: 'Roboto Condensed, sans-serif',
            fontSize: '15px',
            fontWeight: isActive ? 500 : 400,
            marginBottom: '-1px'
          }} data-id="element-1623">
                {isEditing ? <input ref={editInputRef} type="text" value={editTabName} onChange={e => setEditTabName(e.target.value)} onBlur={handleSaveTabName} onKeyDown={handleKeyDownTabName} style={{
              fontFamily: 'Roboto Condensed, sans-serif',
              fontSize: '15px',
              fontWeight: 500,
              color: '#293B54',
              border: 'none',
              outline: 'none',
              background: 'transparent',
              width: `${Math.max(editTabName.length * 9, 60)}px`,
              padding: 0
            }} data-id="element-1624" /> : <span className="select-none whitespace-nowrap" data-id="element-1625">
                    {tab.name}
                  </span>}

                {tabs.length > 1 && !isEditing && <button onClick={e => handleRemoveTab(e, tab.id)} className={`flex items-center justify-center rounded-full p-0.5 transition-colors ${isActive ? 'opacity-100' : 'opacity-0 group-hover:opacity-100'}`} style={{
              color: '#AAAAAA',
              border: 'none',
              background: 'transparent',
              cursor: 'pointer'
            }} onMouseEnter={e => e.currentTarget.style.color = '#EA5455'} onMouseLeave={e => e.currentTarget.style.color = '#AAAAAA'} aria-label="Chiudi vista" data-id="element-1626">
                    <XIcon size={14} data-id="element-1627" />
                  </button>}
              </div>;
        })}

          <button onClick={handleAddTab} className="flex items-center gap-1 transition-colors mb-2 ml-2" style={{
          padding: '8px 12px',
          color: '#AAAAAA',
          fontFamily: 'Roboto Condensed, sans-serif',
          fontSize: '14px',
          fontWeight: 400,
          background: 'transparent',
          border: 'none',
          cursor: 'pointer',
          borderRadius: '4px'
        }} onMouseEnter={e => e.currentTarget.style.backgroundColor = '#F5F5F5'} onMouseLeave={e => e.currentTarget.style.backgroundColor = 'transparent'} data-id="element-1628">
            <span className="flex items-center justify-center" data-id="element-1629">
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-1630">
                <line x1="12" y1="5" x2="12" y2="19" data-id="element-1631"></line>
                <line x1="5" y1="12" x2="19" y2="12" data-id="element-1632"></line>
              </svg>
            </span>
            Nuova vista
          </button>
        </div>
      </div>

      {/* Table Card */}
      <div className="bg-white" style={{
      boxShadow: 'none',
      border: '1px solid #E4E4E4',
      borderRadius: '8px',
      overflow: 'hidden'
    }} data-id="element-1633">
        {/* Toolbar */}
        <div className="p-4 border-b border-gray-200 flex items-center gap-4 bg-gray-50/50" data-id="element-1634">
          <div className="relative w-[300px]" data-id="element-1635">
            <SearchIcon size={16} className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400" data-id="element-1636" />
            <input type="text" placeholder="Cerca soggetti proponenti..." value={searchQuery} onChange={e => updateActiveTab({
            searchQuery: e.target.value
          })} className="w-full h-9 pl-9 pr-3 border border-gray-200 text-sm font-roboto focus:outline-none focus:border-navy-primary bg-white" data-id="element-1637" />
          </div>
          <button className="h-9 w-9 flex items-center justify-center border border-gray-200 text-gray-500 hover:bg-white bg-white" data-id="element-1638">
            <Settings2Icon size={16} data-id="element-1639" />
          </button>
        </div>

        {/* Table with horizontal scroll */}
        <div className="overflow-x-auto" data-id="element-1640">
          <table className="w-full min-w-[1800px] border-collapse" data-id="element-1641">
            <thead data-id="element-1642">
              <tr className="border-b border-gray-200" style={{
              backgroundColor: '#FFFFFF'
            }} data-id="element-1643">
                <th className="text-left p-4 text-xs font-medium text-navy-primary uppercase tracking-wider whitespace-nowrap" style={{
                minWidth: '200px'
              }} data-id="element-1644">
                  Nome Societa
                </th>
                <th className="text-left p-4 text-xs font-medium text-navy-primary uppercase tracking-wider whitespace-nowrap" style={{
                minWidth: '200px'
              }} data-id="element-1645">
                  Email
                </th>
                <th className="text-left p-4 text-xs font-medium text-navy-primary uppercase tracking-wider whitespace-nowrap" style={{
                minWidth: '150px'
              }} data-id="element-1646">
                  Codice Fiscale
                </th>
                <th className="text-left p-4 text-xs font-medium text-navy-primary uppercase tracking-wider whitespace-nowrap" style={{
                minWidth: '180px'
              }} data-id="element-1647">
                  Codice Fiscale Rapp. Legale
                </th>
                <th className="text-left p-4 text-xs font-medium text-navy-primary uppercase tracking-wider whitespace-nowrap" style={{
                minWidth: '180px'
              }} data-id="element-1648">
                  Email Rapp. Legale
                </th>
                <th className="text-left p-4 text-xs font-medium text-navy-primary uppercase tracking-wider whitespace-nowrap" style={{
                minWidth: '180px'
              }} data-id="element-1649">
                  Email Utente
                </th>
                <th className="text-left p-4 text-xs font-medium text-navy-primary uppercase tracking-wider whitespace-nowrap" style={{
                minWidth: '180px'
              }} data-id="element-1650">
                  Nome Utente
                </th>
                <th className="text-left p-4 text-xs font-medium text-navy-primary uppercase tracking-wider whitespace-nowrap" style={{
                minWidth: '150px'
              }} data-id="element-1651">
                  Partita IVA
                </th>
                <th className="text-left p-4 text-xs font-medium text-navy-primary uppercase tracking-wider whitespace-nowrap" style={{
                minWidth: '160px'
              }} data-id="element-1652">
                  Codice Meccanografico
                </th>
                <th className="text-left p-4 text-xs font-medium text-navy-primary uppercase tracking-wider whitespace-nowrap" style={{
                minWidth: '140px'
              }} data-id="element-1653">
                  Telefono
                </th>
                <th className="text-left p-4 text-xs font-medium text-navy-primary uppercase tracking-wider whitespace-nowrap" style={{
                minWidth: '180px'
              }} data-id="element-1654">
                  Forma Giuridica
                </th>
                <th className="text-center p-4 text-xs font-medium text-navy-primary uppercase tracking-wider sticky right-0 bg-white" style={{
                minWidth: '120px',
                boxShadow: '-4px 0 8px -4px rgba(0,0,0,0.1)'
              }} data-id="element-1655">
                  Azioni
                </th>
              </tr>
            </thead>
            <tbody data-id="element-1656">
              {/* Filter Row */}
              <tr className="bg-white border-b border-gray-100" data-id="element-1657">
                <td className="p-2 pl-4" data-id="element-1658">
                  <input type="text" placeholder="Filtra nome_societa..." value={filters.nomeSocieta} onChange={e => handleFilterChange('nomeSocieta', e.target.value)} className="w-full h-8 px-2 border border-gray-200 text-xs text-gray-600 placeholder:text-gray-300" data-id="element-1659" />
                </td>
                <td className="p-2" data-id="element-1660">
                  <input type="text" placeholder="Filtra email..." value={filters.email} onChange={e => handleFilterChange('email', e.target.value)} className="w-full h-8 px-2 border border-gray-200 text-xs text-gray-600 placeholder:text-gray-300" data-id="element-1661" />
                </td>
                <td className="p-2" data-id="element-1662">
                  <input type="text" placeholder="Filtra codice_fiscale..." value={filters.codiceFiscale} onChange={e => handleFilterChange('codiceFiscale', e.target.value)} className="w-full h-8 px-2 border border-gray-200 text-xs text-gray-600 placeholder:text-gray-300" data-id="element-1663" />
                </td>
                <td className="p-2" data-id="element-1664">
                  <input type="text" placeholder="Filtra codice_fiscale_legal..." value={filters.codiceFiscaleRappLegale} onChange={e => handleFilterChange('codiceFiscaleRappLegale', e.target.value)} className="w-full h-8 px-2 border border-gray-200 text-xs text-gray-600 placeholder:text-gray-300" data-id="element-1665" />
                </td>
                <td className="p-2" data-id="element-1666">
                  <input type="text" placeholder="Filtra email_legale_rappresentante..." value={filters.emailRappLegale} onChange={e => handleFilterChange('emailRappLegale', e.target.value)} className="w-full h-8 px-2 border border-gray-200 text-xs text-gray-600 placeholder:text-gray-300" data-id="element-1667" />
                </td>
                <td className="p-2" data-id="element-1668">
                  <input type="text" placeholder="Filtra user_email..." value={filters.emailUtente} onChange={e => handleFilterChange('emailUtente', e.target.value)} className="w-full h-8 px-2 border border-gray-200 text-xs text-gray-600 placeholder:text-gray-300" data-id="element-1669" />
                </td>
                <td className="p-2" data-id="element-1670">
                  <input type="text" placeholder="Filtra user_full_name..." value={filters.nomeUtente} onChange={e => handleFilterChange('nomeUtente', e.target.value)} className="w-full h-8 px-2 border border-gray-200 text-xs text-gray-600 placeholder:text-gray-300" data-id="element-1671" />
                </td>
                <td className="p-2" data-id="element-1672">
                  <input type="text" placeholder="Filtra partita_iva..." value={filters.partitaIva} onChange={e => handleFilterChange('partitaIva', e.target.value)} className="w-full h-8 px-2 border border-gray-200 text-xs text-gray-600 placeholder:text-gray-300" data-id="element-1673" />
                </td>
                <td className="p-2" data-id="element-1674">
                  <input type="text" placeholder="Filtra codice_mecca..." value={filters.codiceMeccanografico} onChange={e => handleFilterChange('codiceMeccanografico', e.target.value)} className="w-full h-8 px-2 border border-gray-200 text-xs text-gray-600 placeholder:text-gray-300" data-id="element-1675" />
                </td>
                <td className="p-2" data-id="element-1676">
                  <input type="text" placeholder="Filtra telefono..." value={filters.telefono} onChange={e => handleFilterChange('telefono', e.target.value)} className="w-full h-8 px-2 border border-gray-200 text-xs text-gray-600 placeholder:text-gray-300" data-id="element-1677" />
                </td>
                <td className="p-2" data-id="element-1678">
                  <select value={filters.formaGiuridica} onChange={e => handleFilterChange('formaGiuridica', e.target.value)} className="w-full h-8 px-2 border border-gray-200 text-xs text-gray-600 bg-white" data-id="element-1679">
                    {formaGiuridicaOptions.map(option => <option key={option} value={option} data-id="element-1680">
                        {option}
                      </option>)}
                  </select>
                </td>
                <td className="p-2 sticky right-0 bg-white" style={{
                boxShadow: '-4px 0 8px -4px rgba(0,0,0,0.1)'
              }} data-id="element-1681"></td>
              </tr>

              {/* Data Rows */}
              {currentData.map(row => <tr key={row.id} className="border-b border-gray-100 hover:bg-blue-50 transition-colors" data-id="element-1682">
                  <td className="p-4 text-sm text-blue-600 font-roboto" data-id="element-1683">
                    <Link to={`/soggetti-proponenti/dettaglio/${row.id}`} className="hover:underline" data-id="element-1684">
                      {row.nomeSocieta}
                    </Link>
                  </td>
                  <td className="p-4 text-sm text-blue-600 font-roboto" data-id="element-1685">
                    {row.email}
                  </td>
                  <td className="p-4 text-sm text-[#8C919A] font-roboto" data-id="element-1686">
                    {row.codiceFiscale}
                  </td>
                  <td className="p-4 text-sm text-[#8C919A] font-roboto" data-id="element-1687">
                    {row.codiceFiscaleRappLegale}
                  </td>
                  <td className="p-4 text-sm text-blue-600 font-roboto" data-id="element-1688">
                    {row.emailRappLegale}
                  </td>
                  <td className="p-4 text-sm text-blue-600 font-roboto" data-id="element-1689">
                    {row.emailUtente}
                  </td>
                  <td className="p-4 text-sm text-[#8C919A] font-roboto" data-id="element-1690">
                    {row.nomeUtente}
                  </td>
                  <td className="p-4 text-sm text-[#8C919A] font-roboto" data-id="element-1691">
                    {row.partitaIva}
                  </td>
                  <td className="p-4 text-sm text-[#8C919A] font-roboto" data-id="element-1692">
                    {row.codiceMeccanografico || '-'}
                  </td>
                  <td className="p-4 text-sm text-[#8C919A] font-roboto" data-id="element-1693">
                    {row.telefono}
                  </td>
                  <td className="p-4 text-sm text-[#8C919A] font-roboto" data-id="element-1694">
                    {row.formaGiuridica}
                  </td>
                  <td className="p-4 text-center sticky right-0 bg-white" style={{
                boxShadow: '-4px 0 8px -4px rgba(0,0,0,0.1)'
              }} data-id="element-1695">
                    <div className="flex items-center justify-center gap-1" data-id="element-1696">
                      <Link to={`/soggetti-proponenti/dettaglio/${row.id}`} className="p-1.5 text-gray-400 hover:text-navy-primary hover:bg-gray-100 rounded transition-colors" data-id="element-1697">
                        <EyeIcon size={18} data-id="element-1698" />
                      </Link>
                      {row.canDelete && <button onClick={() => handleResetClick(row.id)} className="p-1.5 text-gray-400 hover:text-navy-primary hover:bg-gray-100 rounded transition-colors" data-id="element-1699">
                          <RefreshCwIcon size={18} data-id="element-1700" />
                        </button>}
                      <button onClick={() => handleDeleteClick(row)} className="p-1.5 text-gray-400 hover:text-red-600 hover:bg-red-50 rounded transition-colors" data-id="element-1701">
                        <TrashIcon size={18} data-id="element-1702" />
                      </button>
                    </div>
                  </td>
                </tr>)}
            </tbody>
          </table>
        </div>

        {/* Pagination */}
        <div className="p-4 border-t border-gray-200 flex items-center justify-end gap-4 text-sm text-gray-600" data-id="element-1703">
          <div className="flex items-center gap-2" data-id="element-1704">
            <span data-id="element-1705">Righe per pagina:</span>
            <select value={rowsPerPage} onChange={e => updateActiveTab({
            rowsPerPage: Number(e.target.value),
            currentPage: 1
          })} className="border-none bg-transparent font-medium focus:outline-none cursor-pointer" data-id="element-1706">
              <option value={10} data-id="element-1707">10</option>
              <option value={25} data-id="element-1708">25</option>
              <option value={50} data-id="element-1709">50</option>
            </select>
          </div>
          <span data-id="element-1710">
            {startItem}-{endItem} di {totalItems}
          </span>
          <div className="flex items-center gap-1" data-id="element-1711">
            <button onClick={() => updateActiveTab({
            currentPage: Math.max(1, currentPage - 1)
          })} disabled={currentPage === 1} className="p-1 hover:bg-gray-100 rounded disabled:opacity-50" data-id="element-1712">
              <ChevronLeftIcon size={20} data-id="element-1713" />
            </button>
            <button onClick={() => updateActiveTab({
            currentPage: Math.min(totalPages, currentPage + 1)
          })} disabled={currentPage === totalPages || totalPages === 0} className="p-1 hover:bg-gray-100 rounded disabled:opacity-50" data-id="element-1714">
              <ChevronRightIcon size={20} data-id="element-1715" />
            </button>
          </div>
        </div>
      </div>

      {/* Delete Confirmation Dialog */}
      {deleteDialog.isOpen && <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50" data-id="element-1716">
          <div className="bg-white w-[450px] shadow-xl p-6" data-id="element-1717">
            <div className="flex items-start gap-4 mb-4" data-id="element-1718">
              <div className="p-2 bg-red-100 rounded-full text-red-600" data-id="element-1719">
                <AlertTriangleIcon size={24} data-id="element-1720" />
              </div>
              <div data-id="element-1721">
                <h3 className="text-lg font-medium text-navy-primary mb-2 font-roboto" data-id="element-1722">
                  {deleteDialog.canDelete ? 'Elimina Soggetto Proponente' : 'Impossibile eliminare'}
                </h3>
                <p className="text-gray-600 text-sm font-roboto leading-relaxed" data-id="element-1723">
                  {deleteDialog.canDelete ? "Sei sicuro di voler eliminare questo soggetto proponente? Questa azione eliminerà anche l'utente associato e tutte le candidature collegate." : 'Impossibile eliminare questo soggetto proponente perché ha candidature in corso. È necessario prima revocare o eliminare le candidature associate.'}
                </p>
              </div>
            </div>
            <div className="flex justify-end gap-3 mt-6" data-id="element-1724">
              <Button variant="outlined" onClick={() => setDeleteDialog({
            isOpen: false,
            soggettoId: null,
            canDelete: true
          })} data-id="element-1725">
                {deleteDialog.canDelete ? 'Annulla' : 'Chiudi'}
              </Button>
              {deleteDialog.canDelete && <Button variant="primary" onClick={confirmDelete} className="bg-red-600 hover:bg-red-700 focus:ring-red-600 border-transparent" data-id="element-1726">
                  Elimina
                </Button>}
            </div>
          </div>
        </div>}

      {/* Reset Confirmation Dialog */}
      {resetDialog.isOpen && <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50" data-id="element-1727">
          <div className="bg-white w-[450px] shadow-xl p-6" data-id="element-1728">
            <div className="flex items-start gap-4 mb-4" data-id="element-1729">
              <div className="p-2 bg-orange-100 rounded-full text-orange-600" data-id="element-1730">
                <RefreshCwIcon size={24} data-id="element-1731" />
              </div>
              <div data-id="element-1732">
                <h3 className="text-lg font-medium text-navy-primary mb-2 font-roboto" data-id="element-1733">
                  Reset Soggetto Proponente
                </h3>
                <p className="text-gray-600 text-sm font-roboto leading-relaxed" data-id="element-1734">
                  Sei sicuro di voler resettare questo soggetto proponente allo
                  stato iniziale? Tutti i dati inseriti verranno cancellati.
                </p>
              </div>
            </div>
            <div className="flex justify-end gap-3 mt-6" data-id="element-1735">
              <Button variant="outlined" onClick={() => setResetDialog({
            isOpen: false,
            soggettoId: null
          })} data-id="element-1736">
                Annulla
              </Button>
              <Button variant="primary" onClick={confirmReset} data-id="element-1737">
                Conferma reset
              </Button>
            </div>
          </div>
        </div>}
    </div>;
}